import { useState, useEffect } from 'react'
import { getConteudoChave, CONTEUDO_CHAVES } from '@/api/adminApi'
import { ClientPageLayout, clientPageStyles as layout } from '@/components/ClientPageLayout'
import { useRequireConteudoFlag } from '@/utils/featureFlags'

export function MapaPage() {
  const { loading: featureLoading } = useRequireConteudoFlag(CONTEUDO_CHAVES.menu_show_mapa)
  const [url, setUrl] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    getConteudoChave(CONTEUDO_CHAVES.mapa_url)
      .then((v) => { if (!cancelled) setUrl(v ?? '') })
      .catch(() => { if (!cancelled) setUrl('') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [])

  const trimmed = url.trim()
  const isEmbed = /embed|view\.google\.com|pb=/.test(trimmed)
  const embedSrc = isEmbed ? trimmed : ''
  const linkUrl = trimmed.startsWith('http')
    ? trimmed
    : `https://www.google.com/maps?q=${encodeURIComponent(trimmed)}`

  if (featureLoading) return null

  return (
    <ClientPageLayout
      loading={loading}
      empty={!trimmed}
      emptyMessage="A localização será adicionada em breve."
      emptyIcon="🗺️"
    >
      <div className={layout.card}>
        <p className={layout.lead}>Veja como chegar até nós.</p>
        <div className={layout.mapFrame}>
          {embedSrc ? (
            <iframe title="Localização" src={embedSrc} className={layout.mapIframe} />
          ) : (
            <div className={layout.mapLinkBox}>
              <span aria-hidden style={{ fontSize: '2.5rem' }}>
                📍
              </span>
              <a href={linkUrl} target="_blank" rel="noopener noreferrer" className={layout.mapLinkBtn}>
                Abrir no Google Maps
              </a>
            </div>
          )}
        </div>
        <a href={linkUrl} target="_blank" rel="noopener noreferrer" className={layout.mapFooterLink}>
          Ver rota no Google Maps →
        </a>
      </div>
    </ClientPageLayout>
  )
}
